var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Datepicker.tsx
import { TextField } from "@availity/mui-textfield";
import { CalendarDaysIcon } from "@availity/mui-icon";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { jsx } from "react/jsx-runtime";
var paperProps = { elevation: 8, variant: "elevation", sx: { marginTop: "4px" } };
var PickerTextField = (params) => /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({}, params), { placeholder: "MM/DD/YYYY" }));
var Datepicker = (_a) => {
  var _b = _a, { FieldProps, placement = "bottom-start" } = _b, props = __objRest(_b, ["FieldProps", "placement"]);
  var _a2, _b2, _c, _d, _e, _f;
  return /* @__PURE__ */ jsx(
    MuiDatePicker,
    __spreadProps(__spreadValues({}, props), {
      dayOfWeekFormatter: (weekday) => weekday.format("dd"),
      slotProps: {
        desktopPaper: paperProps,
        mobilePaper: __spreadProps(__spreadValues({}, paperProps), {
          "aria-label": ((_a2 = FieldProps == null ? void 0 : FieldProps.label) == null ? void 0 : _a2.toString()) || ((_b2 = FieldProps == null ? void 0 : FieldProps.inputProps) == null ? void 0 : _b2["aria-label"]) || "Date picker",
          "aria-labelledby": ((_c = FieldProps == null ? void 0 : FieldProps.inputProps) == null ? void 0 : _c["aria-labelledby"]) || void 0
        }),
        textField: FieldProps,
        popper: {
          placement,
          "aria-label": ((_d = FieldProps == null ? void 0 : FieldProps.label) == null ? void 0 : _d.toString()) || ((_e = FieldProps == null ? void 0 : FieldProps.inputProps) == null ? void 0 : _e["aria-label"]) || "Date picker",
          "aria-labelledby": ((_f = FieldProps == null ? void 0 : FieldProps.inputProps) == null ? void 0 : _f["aria-labelledby"]) || void 0
        },
        openPickerIcon: {
          fontSize: "xsmall"
        }
      },
      slots: {
        openPickerIcon: CalendarDaysIcon,
        textField: PickerTextField
      }
    })
  );
};
export {
  Datepicker
};
